import { Button } from '@rocco/components/button';
import { ReactComponent as EnquiryIcon } from '@rocco/icons/svg/message.svg';
import { BASE_STYLE } from './style';
import type { ProfessionalMessageProps } from './types';
import { capitalize } from './utils';

/**
 * Provides action buttons for contacting professionals and navigating between team members
 */

interface ActionButtonsProps {
    name: string;
    summary: boolean;
    onMessageClick: (
        professionalProps: ProfessionalMessageProps,
        name: string
    ) => void;
    professionalProps: ProfessionalMessageProps;
    category: string;
}

export const ActionButtons = ({
    name,
    onMessageClick,
    professionalProps,
    category,
    summary,
}: ActionButtonsProps) => {
    const categoryName =
        capitalize(category) === 'Interiordesigners'
            ? 'Interior Designer'
            : capitalize(category);
    return (
        <div
            className={`flex ${BASE_STYLE.GAP_STANDARD} w-full opacity-100 ${BASE_STYLE.BOTTOM_MARGIN}`}
            style={
                summary
                    ? BASE_STYLE.INLINE_STYLES.FADE_IN_SLOWER
                    : BASE_STYLE.INLINE_STYLES.FADE_IN_SLOW
            }
        >
            <Button
                type="button"
                color="dark"
                onClick={() => onMessageClick(professionalProps, name)}
            >
                <span
                    className={`flex items-center ${BASE_STYLE.GAP_STANDARD}`}
                >
                    Message {categoryName}
                    <EnquiryIcon
                        aria-label={`Message ${name}`}
                        className="w-4 fill-white"
                    />
                </span>
            </Button>
        </div>
    );
};
